/* 实例公共扩展函数 */

import axios from 'axios'
import router from '../router'
import NProgress from 'nprogress' // progress bar
import { SUCCESS_OK, BASE_URL } from '@/constant'

export default {
    install(Vue, options) {
        // 请求配置
        Vue.prototype.$http = (method, url, config = method === 'POST' ? {
            showMsg: false,
            data: {}
        } : {
            showMsg: false
        }) => {
            // 创建实例
            const service = axios.create({
                baseURL: BASE_URL, // 基准地址
                timeout: 20000 // 超时时间
                // 定义http状态码为多少时才未resolved状态
                // validateStatus: (status) => {
                //     return status === 200
                // }
            })

            // 请求拦截器
            service.interceptors.request.use(config => {
                const token = sessionStorage.getItem('token')
                // 如果当前有token，则请求头加上token
                if (token) {
                    config.headers['authorization'] = token
                }
                // loading处理
                if (typeof config.loading === 'string') {
                    try {
                        config.self[config.loading] = true
                    } catch (error) {
                        Vue.prototype.warn('未传self对象', 'this')
                    }
                } else if (Array.isArray(config.loading)) {
                    try {
                        config.loading.forEach(item => {
                            config.self[item] = true
                        })
                    } catch (error) {
                        Vue.prototype.warn('未传self对象', 'this')
                    }
                }
                return config
            }, error => {
                Promise.reject(error)
            })

            // 返回拦截器
            service.interceptors.response.use(
                response => {
                    const code = response.data && response.data.code
                    // loading处理
                    if (typeof config.loading === 'string') {
                        try {
                            config.self[config.loading] = false
                        } catch (error) { }
                    } else if (Array.isArray(config.loading)) {
                        try {
                            config.loading.forEach(item => {
                                config.self[item] = false
                            })
                        } catch (error) { }
                    }
                    if (config.showMsg) {
                        Vue.prototype.$message({
                            message: response.data.message,
                            type: code === SUCCESS_OK ? 'success' : 'error'
                        })
                    }
                    return Promise.resolve(response)
                },
                error => {
                    // loading处理
                    if (typeof config.loading === 'string') {
                        try {
                            config.self[config.loading] = false
                        } catch (error) { }
                    } else if (Array.isArray(config.loading)) {
                        try {
                            config.loading.forEach(item => {
                                config.self[item] = false
                            })
                        } catch (error) { }
                    }
                    const code = error.response && error.response.status
                    switch (code) {
                        case 400:
                            Vue.prototype.$message({
                                message: error.response.data.error,
                                type: 'error'
                            })
                            break
                        case 401:
                            Vue.prototype.$message({
                                message: '页面超时，请重新登录',
                                type: 'error'
                            })
                            NProgress.done()
                            router.push('/login')
                            break
                        case 500:
                            Vue.prototype.$message({
                                message: '服务器发生错误,请联系管理员',
                                type: 'error'
                            })
                            break
                        case 504:
                            Vue.prototype.$message({
                                message: '504，接口发布中...',
                                type: 'error'
                            })
                            break
                        default:
                            break
                    }
                    return Promise.reject(error)
                }
            )

            return service({
                method: method,
                url: url,
                ...config
            })
        }

        // 删除提示
        Vue.prototype.$del = () => {
            return new Promise((resolve, reject) => {
                Vue.prototype.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        }

        // 控制台报错
        Vue.prototype.warn = (key, value) => {
            // console.log('%c3D Text', ' text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);font-size:12px')
            console.warn(`%c ${key} %c ${value} %c`,
                'background:#f56c6c ; font-family:Miscrosoft YaHei; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
                'background:#cf9236 ;font-family:Miscrosoft YaHei; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff', 'background:transparent')
        }

        // 获取数据字典
        Vue.prototype.findLookupList = (key) => {
            const lookupList = JSON.parse(sessionStorage.getItem('lookupList'))
            let lookupItemList = []
            try {
                lookupItemList = lookupList.find(item => item.key === key).lookupValues
            } catch (error) {
                Vue.prototype.warn('未找到匹配的数据字典', key)
            }
            return lookupItemList
        }

        // 列表数据字典解码
        Vue.prototype.formatLookup = (lookup, val) => {
            let lookupList = JSON.parse(sessionStorage.getItem('lookupList'))
            let itemArr = []
            let result = ''
            try {
                itemArr = lookupList.find(item => item.key === lookup).lookupValues
            } catch (error) {
                Vue.prototype.warn('未找到匹配的数据字典', lookup)
            }
            result = (itemArr.find(item => item.value === val) || {}).label
            return result
        }

        Vue.prototype.formatTime = (row, column, timestamp) => {
            return timestamp ? new Date(timestamp).format('yyyy-MM-dd hh:mm:ss') : ''
        }

        Vue.prototype.formatDate = (row, column, timestamp) => {
            return timestamp ? new Date(timestamp).toLocaleDateString() : ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/install.js